import { render, staticRenderFns } from "./EventSelectColumn.vue?vue&type=template&id=2ca44a9d&scoped=true&"
import script from "./EventSelectColumn.vue?vue&type=script&lang=js&"
export * from "./EventSelectColumn.vue?vue&type=script&lang=js&"
import style0 from "./EventSelectColumn.vue?vue&type=style&index=0&id=2ca44a9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca44a9d",
  null
  
)

export default component.exports